import React, { useEffect } from 'react'
import GuestContent from '../event-detail/components/guest-content'
import { DefaultLayout } from '../../layouts'
import { Container, SimplePageHeader } from '../../components'
import { useViewport } from '../../utils'
import { fetchEvent } from '../../features/event/slice'
import { useDispatch } from 'react-redux'

const EventRegister = ({ match }) => {
  const { isMobile } = useViewport()
  const dispatch = useDispatch()

  useEffect(() => {
    if(match.params.id){
      dispatch(fetchEvent(match.params.id))
    }

    // eslint-disable-next-line
  }, [])

  return (
    <DefaultLayout>
      <SimplePageHeader noPadding />
      {
        isMobile &&
        <hr className="mt-1 mb-5"/>
      }
      <Container>
        <GuestContent />
      </Container>
    </DefaultLayout>
  )
}

export { EventRegister }
